import './widget/modal';
import './search/more-boletins';
import './public/archive';